import React from "react";
import PropTypes from "prop-types";
import { StyledPdfLink } from "./_.styled";
import { logPdfViewed } from "../../../util/analytics";

const ContentHeaderPdfFilesContainer = ({
  pdfFiles,
  telemetryData,
  handleOpenPdf,
}) => {
  const handleOpenPdfLink = ({ url, language }) => {
    handleOpenPdf(url);
    logPdfViewed({
      title: telemetryData.title,
      recordAn: telemetryData.recordAn,
      language,
    });
  };

  return pdfFiles.map((pdf) => (
    <StyledPdfLink
      kind="anchor"
      key={pdf.url}
      onClick={() => handleOpenPdfLink(pdf)}
    >
      {pdf.language}
    </StyledPdfLink>
  ));
};

ContentHeaderPdfFilesContainer.displayName = "ContentHeaderPdfFilesContainer";
ContentHeaderPdfFilesContainer.propTypes = {
  pdfFiles: PropTypes.array.isRequired,
  telemetryData: PropTypes.shape({
    title: PropTypes.string,
    recordAn: PropTypes.string,
  }).isRequired,
  handleOpenPdf: PropTypes.func.isRequired,
};

export default ContentHeaderPdfFilesContainer;
